import BoletimSection from "../BoletimSection/BoletimSection";
import BoletimSubsection from "../BoletimSubsection/BoletimSubsection";
import Box from "../Box/Box";
import ProgressBar from "../ProgressBar/ProgressBar";
import StudentSuccess from "../StudentSuccess/StudentSuccess";

import styles from "./LinkLabs.module.css";

function LinkLabs({ linkLabs, showHubs = true, student_success = false }) {
    return (
        <BoletimSection title="Link Labs" icon="bulb">
            {showHubs && (
                <BoletimSubsection subtitle={"Hubs"}>
                    <div className={styles.container}>
                        {linkLabs.length > 1 ? (
                            linkLabs.map(({ type, labs, total }, i) => (
                                <>
                                    <Box size={12} />
                                    <ProgressBar
                                        title={type}
                                        value={labs}
                                        maxValue={total}
                                        valueType=" hubs"
                                    />
                                    {i + 1 == linkLabs.length && (
                                        <Box size={24} />
                                    )}
                                </>
                            ))
                        ) : (
                            <ProgressBar
                                value={linkLabs.labs}
                                maxValue={linkLabs.total}
                                valueType=" hubs"
                            />
                        )}
                    </div>
                </BoletimSubsection>
            )}
            {student_success && (
                <BoletimSubsection subtitle={"Student Success"}>
                    <div className={styles.container}>
                        <StudentSuccess
                            mentoria={student_success.mentoria}
                            workshop_fast_track={
                                student_success.workshop_fast_track
                            }
                            workshop={student_success.workshop}
                        />
                    </div>
                </BoletimSubsection>
            )}
        </BoletimSection>
    );
}

export default LinkLabs;
